import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";

type ModalAddressBookingProps = {
    setModalAddressBooking: React.Dispatch<React.SetStateAction<boolean>>;
};

export function ModalAddressBooking({
    setModalAddressBooking
}: Readonly<ModalAddressBookingProps>) {
  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 shadow-2xl">
      <div className="bg-white w-full m-4 md:m-auto md:w-1/3 relative dark:bg-neutral-800 p-8 rounded-2xl shadow-lg">
        <div className="flex justify-between items-center mb-8">
            <h6 className="flex-1 text-xl font-medium text-center">
                Por favor, finalize o preenchimento de seus dados para poder seguir com as reservas
            </h6>
            <button
                className="text-neutral-500 dark:text-neutral-400 absolute top-4 right-4"
                onClick={() => setModalAddressBooking(false)}
            >
                <IoMdClose size={20} />
            </button>
        </div>
        <div className="w-full mt-4 flex gap-2 justify-between items-center">
            <button
                type="button"
                className={`
                bg-neutral-200 hover:bg-neutral-400/60 dark:bg-neutral-700 
                hover:dark:bg-neutral-700/60 transition-colors duration-500 
                ease-in-out text-neutral-900 dark:text-neutral-200 px-6 w-1/2
                py-2 rounded-full disabled:cursor-not-allowed disabled:bg-neutral-200
                disabled:hover:bg-neutral-200 dark:disabled:bg-neutral-700 
                dark:disabled:hover:bg-neutral-700 text-sm md:text-base
                `}
                onClick={() => setModalAddressBooking(false)}
            >
                Voltar
            </button>
            <Link
                to="/account-billing"
                className="w-1/2"
            >
                <button
                    type="button"
                    className={`
                        bg-[#4F46E5] hover:bg-[#4F46E5]/80 hover:dark:bg-[#4F46E5]/60 
                        transition-colors duration-500 ease-in-out text-white w-full text-sm md:text-base whitespace-nowrap
                        md:px-6 md:py-2 px-4 py-2 rounded-full disabled:cursor-not-allowed disabled:bg-[#4F46E5]
                        disabled:hover:bg-[#4F46E5] dark:disabled:bg-[#4F46E5] flex justify-center items-center
                    `}
                >
                    Incluir dados
                </button>
            </Link>
        </div>
      </div>
    </section>
  )
}
